import { CustomerPOCModel } from "../models/CustomerPOCModel";
import { client } from "./API";

const CustomerPOCService = {
  async getAllProjectCustomerPOCs(projectId: number) {
    const response = await client({
      method: "get",
      url: `ProjectCustomerPoc/${projectId}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },

  async postProjectCustomerPOCs(projectId: number, data: CustomerPOCModel[]) {
    try {
      const response = await client({
        method: "post",
        url: `ProjectCustomerPoc/PostProjectCustomerPoc/${projectId}`,
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default CustomerPOCService;
